import { Component } from 'react';
import { T, COMMON } from '../../common/js/i18n';

interface Props {
    onClose?: () => void;
}

interface State {
}

export default class ClientDownload extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {};
    }
    render() {
        const link = __webpack_public_path__ + 'client/codegen-client.exe';
        return (
            <div style={{ padding: "0.5em" }}>
                {T({
                    en: (<div>The code export feature is only available on the dedicated client, please <a href={link} target="blank">click here</a> to download the dedicated client.</div>),
                    zh: (<div>导出代码功能只支持在专用客户端上操作，<a href={link} target="blank">点此下载</a>专用客户端。</div>)
                })}
                <div style={{ textAlign: "center", paddingTop: '0.5em' }}>
                    <button type="button" className="btn" onClick={() => {
                        if (this.props.onClose) {
                            this.props.onClose();
                        }
                    }}>{T(COMMON.CLOSE)}</button>
                </div>
            </div>
        );
    }
}
